<mat-horizontal-stepper linear="true" labelPosition="bottom">
  <!-- linear="true" para que tenga que pasar por todos los pasos de forma secuencial-->
  @for (step of steps; track step) {
    <mat-step [completed]="step.complete">
      <ng-template matStepLabel>{{ step.description }}</ng-template>
      <howden-risks-list [step]="step"></howden-risks-list>
    </mat-step>
  }
</mat-horizontal-stepper>
